import * as React from "react";
const SvgFiRrSofa = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sofa_svg__a)">
      <path
        fill="#062147"
        d="M22 9.184V8c0-4.411-3.589-8-8-8h-4C5.589 0 2 3.589 2 8v1.184A3 3 0 0 0 0 12v5.5c0 1.557.795 2.93 2 3.738V23a1 1 0 0 0 2 0v-1.051c.166.019.329.051.5.051h15c.171 0 .334-.032.5-.051V23a1 1 0 0 0 2 0v-1.762a4.5 4.5 0 0 0 2-3.738V12a3 3 0 0 0-2-2.816M10 2h4c3.309 0 6 2.691 6 6v1.184A3 3 0 0 0 18 12v2H6v-2a3 3 0 0 0-2-2.816V8c0-3.309 2.691-6 6-6M4 19.95a2.504 2.504 0 0 1-2-2.45V12c0-.551.449-1 1-1s1 .449 1 1zM6 20v-4h12v4zm16-2.5c0 1.208-.86 2.217-2 2.45V12c0-.551.449-1 1-1s1 .449 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sofa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSofa;
